import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { RefreshCwIcon } from 'lucide-react';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { CryptoCardSkeleton } from '../components/SkeletonLoader';
import { useCryptoData } from '../hooks/useCryptoData';
export function CryptocurrenciesPage() {
  const {
    data: cryptocurrencies,
    loading,
    error,
    lastUpdated,
    refresh
  } = useCryptoData(100);
  const [refreshing, setRefreshing] = useState(false);
  const handleRefresh = async () => {
    setRefreshing(true);
    await refresh();
    setRefreshing(false);
  };
  return <div className="min-h-screen bg-slate-50" data-id="element-243">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-244">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
          <div className="flex items-center justify-between mb-3" data-id="element-246">
            <h1 className="text-4xl font-bold" data-id="element-247">Top Cryptocurrencies</h1>
            <button onClick={handleRefresh} disabled={refreshing} className="flex items-center gap-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors disabled:opacity-50" data-id="element-248">
              <RefreshCwIcon size={18} className={refreshing ? 'animate-spin' : ''} data-id="element-249" />
              <span className="text-sm font-medium" data-id="element-250">Refresh</span>
            </button>
          </div>
          <p className="text-slate-300 text-lg" data-id="element-251">
            Live cryptocurrency prices and market data
          </p>
          {!loading && <p className="text-slate-400 text-sm mt-2" data-id="element-252">
              Last updated: {lastUpdated.toLocaleTimeString()} • Auto-refreshes
              every 60s
            </p>}
        </div>
      </div>

      {error && <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-253">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-254">
            <p className="text-yellow-800 text-sm" data-id="element-255">
              <strong data-id="element-256">Note:</strong> {error}. Showing cached data.
            </p>
          </div>
        </div>}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-257">
        <div className="grid grid-cols-1 gap-4" data-id="element-258">
          {loading && cryptocurrencies.length === 0 ?
        // Initial loading state
        Array.from({
          length: 10
        }).map((_, i) => <CryptoCardSkeleton key={i} data-id="element-259" />) : cryptocurrencies.map(crypto => <Link key={crypto.id} to={`/cryptocurrency/${crypto.id}`} data-id="element-260">
                  <Card className="p-5" hover data-id="element-261">
                    <div className="flex items-center justify-between" data-id="element-262">
                      <div className="flex items-center gap-4" data-id="element-263">
                        <div className="flex items-center gap-3" data-id="element-264">
                          <span className="text-slate-500 font-semibold text-sm w-6" data-id="element-265">
                            {crypto.rank}
                          </span>
                          <img src={crypto.logo} alt={crypto.name} className="w-10 h-10" onError={e => {
                    e.currentTarget.src = 'https://via.placeholder.com/40';
                  }} data-id="element-266" />
                        </div>
                        <div data-id="element-267">
                          <div className="flex items-center gap-2 mb-1" data-id="element-268">
                            <h3 className="font-semibold text-lg" data-id="element-269">
                              {crypto.name}
                            </h3>
                            <span className="text-slate-500 text-sm" data-id="element-270">
                              {crypto.symbol}
                            </span>
                          </div>
                          <TrustScore score={crypto.trustScore} size="sm" data-id="element-271" />
                        </div>
                      </div>

                      <div className="text-right" data-id="element-272">
                        <div className="font-semibold text-lg mb-1" data-id="element-273">
                          $
                          {crypto.price >= 1 ? crypto.price.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  }) : crypto.price.toFixed(6)}
                        </div>
                        <div className={`text-sm font-medium ${crypto.change24h >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-274">
                          {crypto.change24h >= 0 ? '+' : ''}
                          {crypto.change24h.toFixed(2)}%
                        </div>
                      </div>
                    </div>
                  </Card>
                </Link>)}
        </div>
      </div>
    </div>;
}